export const FORM_FIELDS_MAP = {
  Status: {
    key: 'status'
  },
  DeclinationDetails: {
    key: 'declinationDetails'
  }
};

export const SENDOVER_DETAILS_UPDATE_FIELDS_MAP = {
  Status: {
    key: FORM_FIELDS_MAP.Status.key,
    paramKey: 'statusId',
    outboundAccesor: 'id'
  }
};
